import React from 'react';

// The 3-step header, shared by desktop & mobile (identical leaf).
const STEPS = [
  { n: 1, label: 'Function' },
  { n: 2, label: 'Guests' },
  { n: 3, label: 'Members' },
];

export default function StepNav({ vm }) {
  const { step, goStep, canFunctions } = vm;
  return (
    <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
      {STEPS.map(s => {
        const active = step === s.n;
        const disabled = s.n === 1 && !canFunctions;
        return (
          <button
            key={s.n}
            className={`btn sm ${active ? 'primary' : 'light'}`}
            disabled={disabled}
            onClick={() => goStep(s.n)}
            style={{ flex: 1, minWidth: 90, opacity: disabled ? 0.5 : 1 }}
          >
            {s.n}. {s.label}
          </button>
        );
      })}
    </div>
  );
}
